import React from 'react';

interface SectionHeaderProps {
  title: string;
  count?: number;
  description: string;
  icon: React.ReactNode;
  bgColor: string;
}

/**
 * SectionHeader - Reusable section header component
 * 
 * Displays a section header with icon, title, count, and description.
 * Used to separate different sections in admin dashboard.
 */
const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  count,
  description,
  icon,
  bgColor
}) => {
  return (
    <div className={`px-6 py-4 border-b border-gray-200 ${bgColor}`}>
      <div className="flex items-center gap-3">
        <div className={`w-6 h-6 ${bgColor.replace('bg-', 'bg-').replace('-50', '-100')} rounded-lg flex items-center justify-center flex-shrink-0`}>
          {icon}
        </div>
        <div className="flex-1 min-w-0 text-left">
          <h2 className="text-lg font-semibold text-gray-900">
            {count === undefined ? title : `${title} (${count})`}
          </h2>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;
